const useTelegramButtonBack = (telegram: WebView, router: any, route: any) => {
  telegram.BackButton.onClick(() => {
    useNavigateToBack();
  });

  const updateBackButton = (path: string) => {
    const hasBackUrl = sessionStorage.getItem("webapp-back-url");

    if (path === "/ru/client/projects" || path === "/ka/client/projects" || path === "/en/client/projects") {
      if (hasBackUrl) {
        telegram.BackButton.show();
      } else {
        telegram.BackButton.hide();
      }
    } else {
      telegram.BackButton.show();
    }
  };

  updateBackButton(route.path);

  telegram.onEvent("viewportChanged", () => {
    updateBackButton(route.path);
  });

  watchEffect(() => {
    updateBackButton(route.path);
  });
};

export { useTelegramButtonBack };
